export default __webpack_public_path__ + "static/banner-financial-freedom-c4ae7225621c813dc9f7a30be347decd.jpg";